import { useCallback, useEffect, useRef } from "react"
import { io } from "socket.io-client"

export const useSocket = (
  handlers,
  { setIsListening, listeningRef, connectionId }
) => {
  const socketRef = useRef(null)

  useEffect(() => {
    const socket = io(process.env.REACT_APP_SOCKET_API_URL, {
      transports: ["websocket"]
    })

    socketRef.current = socket

    socket.on("connection_success", data => handlers.onConnected?.(data))

    socket.on("whatsapp_status", status => {
      handlers.onConnectionStatus?.(status)

      if (!listeningRef.current || !status?.qr) return

      setIsListening(false)
    })
    socket.on("error", err => handlers.onError?.(err))
    socket.on("disconnect", () => {})

    return () => {
      socket.off("whatsapp_status", () => {
        setIsListening(false)
      })
      socket.disconnect()
    }
  }, [])

  useEffect(() => {
    const socket = socketRef.current
    if (!socket || !connectionId) return

    const handleConnect = () => {
      socket.emit("joinChatBox", `connection:${connectionId}`)
    }

    socket.on("connect", handleConnect)
    socket.on("new_message", message => handlers.onNewMessage?.(message))

    return () => {
      socket.off("connect", handleConnect)
    }
  }, [connectionId])

  const sendMessage = useCallback(payload => {
    if (socketRef.current?.connected) {
      socketRef.current.emit("message", payload)
    } else {
      console.warn("⚠️ Tentativa de enviar mensagem com socket desconectado.")
    }
  }, [])

  return { socket: socketRef.current, sendMessage }
}
